<template>
    <div class="page-wrapper">
        <router-link :to="{name: 'home'}">
            <img alt="Roula Rouva Logo" class="logo" src="@/assets/img/rr-logo.png" />
        </router-link>

        <el-card
            class="box-card login-card"
        >
            <!-- Loader -->
            <el-alert
                v-show="user === undefined"
                type="success"
                :closable="false"
            >
                {{ $t("view.login.authenticating") }}
            </el-alert>

            <!-- Offline instruction -->
            <el-alert
                v-show="!networkOnLine"
                :closable="false"
                type="warning"
            >
                {{ $t("view.login.offline_message") }}
            </el-alert>

            <el-alert
                v-show="loginError"
                :closable="false"
                type="error"
            >
                {{ loginError }}
            </el-alert>

            <div slot="header" class="clearfix">
                <span>Login</span>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <el-form
                        ref="form"
                        :model="form"
                        :rules="rules"
                    >
                        <el-form-item
                            label="Username"
                            for="username"
                            prop="username"
                        >
                            <el-input
                                id="username"
                                v-model="form.username"
                                placeholder="email"
                                type="email"
                            />
                        </el-form-item>
                        <el-form-item
                            label="Password"
                            for="password"
                            prop="password"
                        >
                            <el-input
                                id="password"
                                v-model="form.password"
                                placeholder="Enter Your Password"
                                type="password"
                            />
                        </el-form-item>

                        <el-form-item>
                            <el-button
                                type="primary"
                                class="connect-btn"
                                @click.stop.prevent="loginWithPassword"
                            >
                                Connect
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <el-divider> OR</el-divider>

            <!-- Auth UI -->
            <el-button
                v-show="user !== undefined && !user && networkOnLine"
                size="medium"
                class="googleButton"
                @click="login"
            >
                <img src="@/assets/img/google-icon.png">
                {{ $t("view.login.sign_in_with_google") }}
            </el-button>
        </el-card>


    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import {isNil}                  from "lodash";
import firebase                 from "firebase/app";
import {desktop as isDekstop}   from "is_js";

export default {
    data: () => (
        {
            loginError: null,
            form      : {
                username: "",
                password: ""
            }
        }
    ),
    head() {
        return {
            title: {
                inner: this.$t("view.login.title_login")
            }
        };
    },
    computed: {
        ...mapState(
            "authentication",
            [
                "user"
            ]
        ),
        ...mapState(
            "app",
            [
                "networkOnLine",
                "appTitle"
            ]
        ),
        rules: () => {
            return {
                username: [
                    {
                        require: true,
                        message: "This is a required field.",
                        trigger: "blur"
                    },
                    {
                        validator: (rule, value, callback) => {
                            const validateEmail = (email) => {
                                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                return re.test(String(email).toLowerCase());
                            };

                            if (!validateEmail(value)) {
                                callback("Please enter a valid email address");
                            }

                            callback();
                        },
                        trigger  : "blur"
                    }
                ],
                password: [
                    {
                        require: true,
                        message: "This is a required field.",
                        trigger: "blur"
                    }
                ]
            };
        }
    },
    watch   : {
        user: {
            handler(user) {
                if (!isNil(user)) {
                    const redirectUrl = isNil(this.$route.query.redirectUrl) ? "/dashboard" : this.$route.query.redirectUrl;

                    setTimeout(
                        () => {
                            this.$router.push(redirectUrl);
                        },
                        500
                    );
                }
            },
            immediate: true
        }
    },
    methods : {
        ...mapMutations(
            "authentication",
            [
                "setUser"
            ]
        ),
        async login() {
            this.loginError = null;
            const provider  = new firebase.auth.GoogleAuthProvider();
            this.setUser(undefined);

            try {
                // Firebase signin with popup is faster than redirect
                // but we can't use it on mobile because it's not well supported
                // when app is running as standalone on ios & android
                // eslint-disable-next-line no-unused-expressions
                isDekstop()
                    ? await firebase.auth().signInWithPopup(provider)
                    : await firebase.auth().signInWithRedirect(provider);
            } catch (err) {
                this.loginError = err;
                this.setUser(null);
            }
        },
        async loginWithPassword() {
            this.loginError = null;

            this
                .$refs
                .form
                .validate()
                .then(
                    async () => {
                        try {
                            await firebase
                                .auth()
                                .signInWithEmailAndPassword(
                                    this.form.username,
                                    this.form.password
                                );
                        } catch (err) {
                            this.loginError = err;
                            this.setUser(null);
                        }
                    }
                )
                .catch(
                    () => {
                        console.log('This form is invalid');
                    }
                );
        }
    }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
    display         : flex;
    justify-content : center;
    flex-direction  : column;
    align-items     : center;

    .logo {
        margin-bottom : 3rem;
        max-width     : 180px;
    }

    .googleButton {
        font-size   : 18px;
        font-weight : 600;

        img {
            width         : 20px;
            margin-bottom : -3px;
        }
    }
}

.login-card {
    max-width : 400px;
}

.connect-btn {
    display : block;
    width   : 100%;
}
</style>
